import { useContext } from "react";
import { QueryValidationContext } from "../context";

const useQueryValidationContext = () => {
  const context = useContext(QueryValidationContext);
  if (!context)
    throw new Error(
      "useQueryValidationContext can only be used within QueryValidationProvider"
    );

  return context;
};

export default useQueryValidationContext;
